/**
 * Classe pour l'utilisation de Stripe
 */

import { loadStripe } from '@stripe/stripe-js/pure';

let stripeInstance = null;

export class Stripe {

    // Clé publique
    // publicKey: null

    // Vrai si le SDK a été initialisé
    // sdkLoaded: false

    // Objet Stripe pour appeler l'API
    // api: null

    constructor() {
        this.publicKey = document.head.querySelector('meta[name="stripe-key"]').content;
        this.sdkLoaded = false;
        this.api = null;
    };

    initSDK() {

        return loadStripe(this.publicKey).then((stripe) => {
            this.api = stripe;
            this.sdkLoaded = true;
            return Promise.resolve(this);
        });

    };

    static getInstance() {
        if(stripeInstance === null) {
            return stripeInstance = new Stripe();
        }
        return stripeInstance;
    };

    /**
     * Tentative de confirmation de paiement
     * @param object data :
     *   'email': Adresse email du membre
     * @return void
     */
    confirmCardPayment(data) {

        this.api.createPaymentMethod({
            type: 'card',
            card: data.cardNumber,
            billing_details: {
                email: data.email
            }
        }).then(function(response) {
            const paymentMethodId = (response.paymentMethod && response.paymentMethod.id);
            if(paymentMethodId) {
                return Promise.resolve(response.paymentMethod);
            } else {
                const messageError = (response.error && response.error.message) ? response.error.message : null;
                return Promise.reject(messageError);
            }
        }).catch(() => {
            return Promise.reject();
        });

    };


}

export class StripeForm {

    // API Stripe
    // formId: null
    // api: null

    constructor(formId) {
        this.formId = formId;
        this.api = Stripe.getInstance().api;
    };

    /**
     * Remplit le formulaire avec Stripe.Elements
     * @return void
     */
    fill(onReady) {

        const attributes = {
            style: {
                base: {
                    fontSize: '15px',
                    fontFamily: 'Poppins, sans-serif',
                    lineHeight: '23px'
                }
            }
        };

        const
            stripeElements = this.api.elements(),
            form = document.getElementById(this.formId),
            /***/
            cardNumberElement = form.querySelector('div.input-container-credit-card-number'),
            cardNumber = stripeElements.create('cardNumber', attributes),
            /***/
            cardCVCElement = form.querySelector('div.input-container-credit-card-cvc'),
            cardCVC = stripeElements.create('cardCvc', attributes),
            /***/
            cardExpiryElement = form.querySelector('div.input-container-credit-card-expiry'),
            cardExpiry = stripeElements.create('cardExpiry', attributes),
            /***/
            sepaIbanElement = form.querySelector('div.input-container-sepa-iban'),
            sepaIban = stripeElements.create('iban', { ...attributes, supportedCountries: ['SEPA'] })
        ;

        cardNumber.mount(cardNumberElement);
        cardCVC.mount(cardCVCElement);
        cardExpiry.mount(cardExpiryElement);

        sepaIban.mount(sepaIbanElement);

        cardNumber.on('ready', onReady);

        this.fields = {
            number: cardNumber,
            cvc: cardCVC,
            date: cardExpiry,
            iban: sepaIban
        };

    };

    getFields() {
        return this.fields;
    };

}
